<template>
	<div class="personal">
		<el-form
			:model="formData"
			:rules="rules"
			inline
			:hide-required-asterisk="true"
			ref="personal"
		>
			<el-form-item
				prop="mobile"
				label-width="0.82rem"
			>
				<div class="label qjc-fts-14" slot="label">
					<span>手</span>
					<span>机</span>
					<span>号</span>
				</div>
				<el-input
					:disabled="type == 'update'"
					v-model="formData.mobile"
					type="text"
					placeholder="请输入您的手机号"
					@input="phoneMustNumber"
				></el-input>
				<p v-if="type == 'insert'" class="tip qjc-fts-12">手机号与企业用户ID至少填写一项</p>
			</el-form-item>
			
			<el-form-item
				v-if="type == 'insert'"
				:error="mobileConfirmErr?'手机号输入不一致':''"
				label-width="1.12rem"
			>
				<div class="label qjc-fts-14" slot="label">
					<span>手</span>
					<span>机</span>
					<span>号</span>
					<span>确</span>
					<span>认</span>
				</div>
				<el-input
					v-model="mobileConfirm"
					type="text"
					placeholder="请确认您的手机号"
					@input="phoneConfirmMustNumber"
					@blur="mobileConfirmVerify"
				></el-input>
			</el-form-item>
			
			<el-form-item
				prop="yyuserid"
				:label-width="type == 'insert'?'0.82rem':'1.12rem'"
			>
				<div class="label qjc-fts-14" slot="label">
					<span>企</span>
					<span>业</span>
					<span>用</span>
					<span>户</span>
					<span>ID</span>
				</div>
				<el-input
					:disabled="type == 'update'"
					v-model="formData.yyuserid"
					type="text"
					placeholder="请输入您的企业用户ID"
				></el-input>
				<p v-if="type == 'insert'" class="tip qjc-fts-12">手机号与企业用户ID至少填写一项</p>
			</el-form-item>
			
			<el-form-item
				v-if="type == 'insert'"
				:error="yyuseridConfirmErr?'企业用户ID输入不一致':''"
				label-width="1.12rem"
			>
				<div class="label qjc-fts-14" slot="label">
					<span>企</span>
					<span>业</span>
					<span>用</span>
					<span>户</span>
					<span>ID</span>
					<span>确</span>
					<span>认</span>
				</div>
				<el-input
					v-model="yyuseridConfirm"
					type="text"
					placeholder="请确认您的企业用户ID"
					@blur="yyuseridConfirmVerify"
				></el-input>
			</el-form-item>
			
			<el-form-item
				prop="sex"
				label-width="0.82rem"
			>
				<div class="label qjc-fts-14" slot="label">
					<span>客</span>
					<span>户</span>
					<span>性</span>
					<span>别</span>
				</div>
				<el-select
					v-model="formData.sex"
				>
					<el-option
						label="男"
						value="1"
					></el-option>
					<el-option
						label="女"
						value="2"
					></el-option>
				</el-select>
			</el-form-item>
			
			<el-form-item
				prop="birth"
				label-width="1.12rem"
			>
				<div class="label qjc-fts-14" slot="label">
					<span>出</span>
					<span>生</span>
					<span>日</span>
					<span>期</span>
				</div>
				<el-date-picker
				  v-model="birthSel"
				  type="date"
				  placeholder="请选择"
				  value-format="timestamp"
				  :default-value="new Date('1990/1/1').getTime()"
				>
				</el-date-picker>
			</el-form-item>
			
			<el-form-item
				prop="examdate"
				label-width="0.82rem"
			>
				<div class="label qjc-fts-14" slot="label">
					<span>体</span>
					<span>检</span>
					<span>日</span>
					<span>期</span>
				</div>
				<el-date-picker
				  :disabled="type == 'update'"
				  v-model="examdateSel"
				  type="date"
				  placeholder="请选择"
				  value-format="timestamp"
				  :picker-options="pickerOptions"
				>
				</el-date-picker>
			</el-form-item>
			
			<el-form-item
				prop="examplace"
				label-width="1.12rem"
			>
				<div class="label qjc-fts-14" slot="label">
					<span>体</span>
					<span>检</span>
					<span>地</span>
					<span>点</span>
				</div>
				<el-input
					:disabled="type == 'update'"
					v-model="formData.examplace"
					type="text"
					placeholder="请填写体检地点"
				></el-input>
			</el-form-item>
			
			<h3 class="qjc-fts-16 qjc-c-dark qjc-ftw-500">产品组合</h3>
			
			<el-form-item
				prop="package"
				class="packages qjc-texta-c qjc-relative"
			>
				<el-checkbox-group
					v-model="formData.package"
					class="qjc-clearfix"
				>
					<div class="qjc-fl item-check" :class="item.key == 'base' ? 'qjc-wid-100' : ''" v-for="item in packageList">
						<label class="product qjc-relative qjc-block qjc-fts-14 qjc-ftw-500" 
							   :class="item.key == 'base' ? 'basic' : item.key == 'packageA' ? 'PLM' : item.key == 'packageB' ? 'comorbidity' : item.key == 'packageC'? 'illness' : item.key == 'packageD' ? 'health' : 'base'">
							<el-checkbox
								:label="item.key"
								:disabled="package_opt == '0'"
							></el-checkbox>
							<span class="name qjc-absolute">{{item.name}}</span>
						</label>
						<p class="base-count count" :class="{ 'c-danger': item.times<500 }"> {{pay_mode == '1' ? '剩余次数：'+item.times : pay_mode == '2' ? '已使用次数' + item.used : ''}}次</p>
					</div>
				</el-checkbox-group>
				
			</el-form-item>
			
			<el-button @click="next" class="next qjc-fts-16 qjc-block">下一步</el-button>
			
		</el-form>
	</div>
</template>

<script>
	import { isPhone } from '@/utils'
	import { getPackage } from '@/utils/axios'
	
	export default{
		name: 'personal',
		data() {
			// 验证
			// 手机号
			var mobileVerify = (rule, value, callback) => {
				if(this.formData.yyuserid){
					if(value == ''){
						callback();
					}else if(isPhone(value)){
						callback();
					}else{
						callback(new Error('手机号格式错误'));
					}
				}else{
					if(value == ''){
						callback(new Error('手机号与企业用户ID至少填写一项'));
					}else if(isPhone(value)){
						callback();
					}else{
						callback(new Error('手机号格式错误'));
					}
				}
			}
			
			// 企业用户id验证
			var yyuseridVerify = (rule, value, callback) => {
				if(this.formData.mobile){
					callback();
				}else{
					if(value == ''){
						callback(new Error('手机号与企业用户ID至少填写一项'));
					}else{
						callback();
					}
				}
			}
			
			// 出生日期验证
			var birthVerify = (rule, value, callback) => {
				if(this.birthSel > this.limitTime(90) && this.birthSel <= this.limitTime(20)){
					callback();
				}else{
					callback(new Error('大数据评估仅适用于年龄在20~90周岁之间人群!'));
				}
			}
			
			// 体检日期验证
			var examdateVerify = (rule, value, callback) => {
				let nowDate = new Date();
				let nowTime = new Date(nowDate.getFullYear() + '/' + (nowDate.getMonth()+1) + '/' + nowDate.getDate()).getTime();// 当前日期时间戳
				if(this.type == 'insert' && nowTime > this.examdateSel){
					callback(new Error('体检日期不能小于当前时间'));
				}else{
					callback();
				}
			}
			
			// 基础套餐必选
			var examBasicVerify = (rule, value, callback) => {
				if(value.indexOf('base') != -1){
					callback();
				}else{
					callback(new Error('基础体检套餐必选'));
				}
			}
			
			return {
				mobileConfirm: '',// 手机号确认
				mobileConfirmErr: false,// 手机号确认错误消息显示
				
				yyuseridConfirm: '',// 企业用户id确认
				yyuseridConfirmErr: false,// 手机号确认错误消息显示
				
				rules: {
					mobile: [
						{ validator: mobileVerify, trigger: 'blur' }
					],
					yyuserid: [
						{ validator: yyuseridVerify, trigger: 'blur' }
					],
					// 性别:1男  2女
					sex: [
						{ required: true, message: '请选择客户性别', trigger: 'change' }
					],
					birth: [
						{ required: true, message: '请选择出生日期', trigger: 'blur' },
						{ validator: birthVerify, trigger: 'change' }
					],
					examdate: [
						{ required: true, message: '请选择体检日期', trigger: 'blur' },
						{ validator: examdateVerify, trigger: 'change' }
					],
					examplace: [
						{ required: true, message: '请输入体检地点', trigger: 'blur' }
					],
					package: [
						{ validator: examBasicVerify, trigger: 'change' }
					]
				}, 
				
				count: {
					base: {
						times: 0//默认为0 
					},
					packageA: {
						times: 0//默认为0
					},
					packageB: {
						times: 0//默认为0
					},
					packageC: {
						times: 0//默认为0
					},
					packageD: {
						times: 0//默认为0
					}
				},//套餐剩余次数
				packageList: [],
				package_opt: '1',
				pay_mode: '1',
				// 体检日期不能选择今日以前
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now() - 8.64e7;
					}
				}
				
			}
		},
		computed: {
			birthSel: {// 出生日期展示
				get() {
					if(this.formData.birth){//不能为空
						// 时间戳妙转为毫秒
						return this.formData.birth * 1000;
					}else{
						return '';
					}
					
				},
				set(value) {
					// 毫秒转换为秒
					this.formData.birth = value/1000;
					
				}
			},
			examdateSel: {// 体检日期展示
				get() {
					if(this.formData.examdate){//不能为空
						// 时间戳妙转为毫秒
						return this.formData.examdate * 1000;
					}else{
						return '';
					}
				},
				set(value) {
					// 毫秒转换为秒
					this.formData.examdate = value/1000;
				}
			}
		},
		props: ['type', 'formData', 'reportCode'],
		mounted() {
			getPackage({from: 'yy'}).then(res => {
				if(res.code == 200){
					let data = JSON.parse(window.atob(res.data))
					this.package_opt = data.package_opt;
					this.pay_mode = data.pay_mode;
					let death = data.package
					let deathList = []
					let dieList = []
					for (let j in death) {
						deathList.push([death[j],j]);
					}
					deathList.map((item, index) => {
						let arr = item[0]
						arr.key = item[1]
						dieList.push(arr)
					})
					this.packageList = dieList
					let packageCheckList = [];
					if(data.package_opt == '0') {
						dieList.map((check) => {
							packageCheckList.push(check.key)
						})
					}
					if(packageCheckList.length <= 0) {
						packageCheckList = ['base']
					}
					this.formData.package = [...new Set(packageCheckList)]
				}else{
					this.$myAlert({
						title: res.msg
					});
				}
			});
		},
		methods: {
			// 下一步
			next() {
				if(this.formData.package && (this.formData.package.indexOf('base') == -1)) {
					this.$myAlert({
						title: '基础体检套餐必选',
						content: '基础体检套餐为必选套餐'
					});
					return
				}
				// 报告编码和输入框一致
				if(this.reportCode == this.formData.report_code){
					this.$refs.personal.validate((isSuc, err) => {
						// 验证通过且确认输入也通过
						if(isSuc){
							if(this.type == 'insert' && (!this.mobileConfirmVerify() || !this.yyuseridConfirmVerify())){
								return false;
							}
							
							// 数据修改禁止再次查询
							this.$emit('stopQuery');
							
							// 成功进入下一步
							this.$emit('checkTab', 'Questions');
						}
					});
				}else{
					this.$myAlert({
						title: '报告编码错误',
						content: '您的报告编码已更改，请重新点击查询'
					});
				}
				
			},
			
			// 手机号确认
			mobileConfirmVerify() {
				if(this.mobileConfirm != this.formData.mobile){
					this.mobileConfirmErr = true;
					return false;
				}else{
					this.mobileConfirmErr = false;
					return true;
				}
			},
			
			// 企业用户id确认
			yyuseridConfirmVerify() {
				if(this.yyuseridConfirm != this.formData.yyuserid){
					this.yyuseridConfirmErr = true;
					return false;
				}else{
					this.yyuseridConfirmErr = false;
					return true;
				}
			},
			
			// 距今year年的时间戳 参数:year:距今年份
			limitTime(year) {
				let nowDate = new Date();
				return new Date((nowDate.getFullYear() - year) +'/' + (nowDate.getMonth() + 1) + '/' + nowDate.getDate()).getTime();
			},
			
			// 手机号必须输入数字
			phoneMustNumber(value) {
				this.formData.mobile = value.replace(/\D/g,'');
			},
			phoneConfirmMustNumber(value) {
				this.mobileConfirm = value.replace(/\D/g,'');
			}
		}
	}
</script>

<style scoped>
	.el-form >>> .el-form-item__label{
		line-height: 0.36rem;
	}
	.el-form .el-input >>> input,
	.el-form >>> .el-input__inner{
		height: 0.36rem;
		line-height: 0.16rem;
		font-size: 0.14rem;
	}
	.el-form >>> .el-form-item__content,
	.el-form >>> .el-input__icon{
		line-height: 0.36rem;
	}
	.product .el-checkbox,
	.product >>> .el-checkbox__input{
		position: absolute;
		top: 0;
		left: 0;
	}
	.product >>> .el-checkbox__inner{
		width: 0.18rem;
		height: 0.16rem;
		border-radius: 0.06rem 0 0.06rem 0;
	}
	.product >>> .el-checkbox__inner::after{
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%)rotate(45deg)scaleY(0);
	}
	.product >>> .el-checkbox__input.is-checked .el-checkbox__inner::after{
		transform: translate(-50%,-50%)rotate(45deg)scaleY(1);
	}
	.product >>> .el-checkbox__input.is-checked .el-checkbox__inner, 
	.product >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner{
		border-color: #6681FA;
		background-color: #6681FA;
	}
	.packages >>> .el-checkbox__label{
		display: none;
	}
	.packages >>> .el-form-item__content{
		width: 100%;
	}
	.packages >>> .el-form-item__error{
		position: absolute;
		top: 0.28rem;
		left: 2rem;
	}
</style>
<style lang="scss" scoped>
	.personal{
		padding-top: 0.24rem;
		
		.el-form{
			.el-form-item{
				width: 50%;
				margin-right: 0;
				margin-bottom: 0.12rem;
				
				.label{
					display: flex;
					justify-content: space-between;
					color: #777F8F;
				}
				.el-input,
				.el-select{
					width: 4.4rem;
				}
				.tip{
					line-height: 0.12rem;
					margin-top: 0.06rem;
					color: #ACAEB3;
				}
				.product{
					width: 1.93rem;
					height: 0.56rem;
					line-height: 0.18rem;
					border-radius: 0.06rem 0 0.06rem 0;
					cursor: pointer; 
					
					.name{
						top: 50%;
						left: 50%;
						width: 100%;
						transform: translate(-50%,-50%);
					}
					
					&.basic{
						color: #40444D;
						background-color: #F0F4F7;
					}
					&.PLM{
						color: #C07E37;
						background-color: #FCF9F0;
					}
					&.comorbidity{
						color: #C92B5C;
						background-color: #FCF5F2;
					}
					&.illness{
						color: #5843BE;
						background-color: #F6F5FC;
					}
					&.health{
						color: #1955AF;
						background-color: #F0F6FC;
					}
				}
				p.base-count{
					width: 1.93rem;
					margin-bottom: 0.16rem;
				}
				.count{
					font-size: 0.13rem;
					line-height: 0.13rem;
					color: #777F8F;
					margin-top: 0.06rem;
				}
			
			}
			
			.packages{
				width: 100%;
				margin: 0.16rem 0 0;
				
				.el-checkbox-group{
					display: flex;
					flex-wrap: wrap;
					
					div.qjc-fl{
						margin-right: 0.16rem;
					}
					
					.c-danger{
						color: #FF4C52;
					}
				}
			}
			
			h3{
				margin: 0.4rem 0 0.24rem;
			}
		
			.next{
				width: 2rem;
				height: 0.48rem;
				margin: 0.56rem auto 0;
			}
		}
	}
</style>
